/**
 * Formatierungs-Helfer fuer die Warnlisten-UI (Plan 02-05). `standFmt` 1:1 aus dem
 * Vorbild-Programm uebernommen (dessen Format-Helper-Datei im Nachbar-Ordner);
 * Prozent-/Waehrungs-Helper bewusst weggelassen — artikelleichen hat kein
 * Deckungsbeitrags-Konzept.
 */

/** Formatiert einen ISO-Zeitstempel (Registry-Snapshot-Stand) deutsch, z.B. "09.09.2026, 03:15". */
export function standFmt(iso: string | null): string {
  if (!iso) return 'unbekannt';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'unbekannt';
  return d.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** Deutsches Datum ohne Uhrzeit, z.B. "09.09.2026". `null`/ungueltig -> "—". */
export function datumFmt(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
